"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Viewer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_pdf_1 = require("react-pdf");
react_pdf_1.pdfjs.GlobalWorkerOptions.workerSrc =
    '//cdn.jsdelivr.net/npm/pdfjs-dist@2.12.313/build/pdf.worker.js';
const Viewer = ({ url, currentPage, onLoadProgress, onLoadSuccess, onClick, style, loading, error, noData, }) => {
    return (jsx_runtime_1.jsx("div", { children: jsx_runtime_1.jsx("div", Object.assign({ style: Object.assign({ 
                // make unselectable
                WebkitTouchCallout: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none', userSelect: 'none', cursor: onClick ? 'pointer' : 'auto' }, style), onClick: onClick }, { children: jsx_runtime_1.jsx(react_pdf_1.Document, Object.assign({ file: url, onLoadSuccess: (data) => {
                    onLoadSuccess && onLoadSuccess(data);
                }, onLoadProgress: onLoadProgress, error: error, loading: loading, noData: noData }, { children: jsx_runtime_1.jsx(react_pdf_1.Page, { pageNumber: currentPage, renderAnnotationLayer: false }, void 0) }), void 0) }), void 0) }, void 0));
};
exports.Viewer = Viewer;
//# sourceMappingURL=viewer.js.map